import { Environment } from '../types/environment';
import { getPageIdFromURL, getEnvironment, isEnv } from './env';

export type Page = {
  id: string,
  route: () => string,
};

export const pages: { [name: string]: Page; } = {
  auth: {
    id: 'auth',
    route: () => {
      const { location } = window;
      const { pathname, search, hash } = location;

      const encodedRedirectTo = window.encodeURIComponent(
        `${pathname}${search}${hash}`,
      );

      return `auth/login?to=${encodedRedirectTo}`;
    },
  },
};

export function redirectUser(page: Page) {
  const { location } = window;
  const { hostname, pathname } = location;
  const urlPageId = getPageIdFromURL();

  if (urlPageId !== page.id) {
    let redirectAddress = `https://${hostname}${pathname}#/${page.route()}`;

    if (page.id === 'auth' && !urlPageId) {
      redirectAddress = `https://${hostname}${pathname}#/${page.id}`;
    }

    window.location.replace(redirectAddress);
  }
}

export function getRootUrl() {
  const subDomain = isEnv(Environment.Production) ? '' : `${getEnvironment(window.location.href)}.`;
  return `https://${subDomain}climate.com`;
}
